import Vue from 'vue';
import loginModule from '../store/login/loginModule';
export default {
    post(url: string = '', data: any = null, config: any = null) {
        return new Promise((resolve: any, reject: any) => {
            let UserID: any = localStorage.getItem('UserID');
            let UserToken: any = localStorage.getItem('UserToken');
            let billingList: any = localStorage.getItem('CustomerAccount');
            if (!UserID || !UserToken) {
                reject('Abnormal account');
                loginModule.actions.coercivenesslogout();
                return;
            }
            if (!billingList) {
                reject('Customer switch error exit');
                loginModule.actions.coercivenesslogout();
                return;
            }
            resolve(JSON.parse(billingList));
        });
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/shared/switchBillingToService.ts